import { useEffect, useRef } from "react";
import * as Sentry from "@sentry/react";
import { User } from "@/ts/common-types";
import { showSentryCrashReportModal } from "@/ts/utils";

const useSentryCrashReport = (errorStatusCode: boolean, userDetails: User) => {
    useEffect(() => {
        if (errorStatusCode === true) {
            try {
                throw new Error("Received 5xx status code");
            } catch (error) {
                showSentryCrashReportModal(
                    process.env.VITE_SHOW_CRASH_MODAL === "true",
                    error,
                    userDetails
                );
            }
        }
    }, [errorStatusCode]);
};

export default useSentryCrashReport;
